import React from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import modalStyle from '../../styles/modalStyle';
import { caseColumnDef } from '../../colDef/caseColumnDef';
import apiClient from '../../axiosClient';
import Case from '../../interfaces/case';
import { apiCallWrapper } from '../../utils/commonUtils';

interface CaseUpdateModalProps {
    open: boolean;
    onClose: () => void;
    selectedRows: Case[];
}

const FocusedCaseAssignmentModal: React.FC<CaseUpdateModalProps> = ({ open, onClose, selectedRows }) => {

    const handleSubmit = async () => {
        const body = selectedRows.map((row: Case) => ({
            client_reference_id: row.client_reference_id,
            client_name: row.client_name
        }));

        const response = await apiCallWrapper(() => apiClient.post('api/v1/case/focused_case_allocation', body));

        if (response && response.status === 200) {
            const { message, updated_count } = response.data;
            alert(`${message}\nUpdated Count: ${updated_count}`);
            window.location.reload();
        } else if (response) {
            alert("Focused Case Allocation failed");
        }
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography id="modal-title" variant="h6">
                        Focused Case Assignment
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box mt={3}>
                    <Typography variant="subtitle1">Selected Rows:</Typography>
                    <SearchResultGrid
                        getRowId={(row) => row.case_id}
                        results={selectedRows}
                        onSelectRow={() => { }}
                        columns={caseColumnDef}
                        isRowSelectionAllowed={false}
                    />
                </Box>

                <Box mt={3} textAlign="right">
                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default FocusedCaseAssignmentModal;
